import React from 'react';

import { Box, Col, Paper, Row, Typography } from 'components/AORedesign';

const OneStopClaimReporting = () => {
  return (
    <Paper>
      <Typography variant="h6" style={{ marginBottom: 16 }}>
        One Stop Claim Reporting
      </Typography>

      <Row spacing={3}>
        <Col xs={4}>
          <Typography component="div">
            <Box color="text.secondary" fontSize={12}>
              PHONE
            </Box>
          </Typography>
        </Col>
        <Col xs={8}>
          <Typography component="div">
            <Box fontSize={14}>
              (877) 4CLAIMS
              <br />
              (877) 425-2467
            </Box>
          </Typography>
        </Col>
      </Row>

      <Row spacing={3}>
        <Col xs={4}>
          <Typography component="div">
            <Box color="text.secondary" fontSize={12}>
              FAX
            </Box>
          </Typography>
        </Col>
        <Col xs={8}>
          <Typography component="div">
            <Box fontSize={14}>(877) 282-3844</Box>
          </Typography>
        </Col>
      </Row>

      <Row spacing={3} mb={3} alignItems="flex-start">
        <Col xs={4}>
          <Typography component="div">
            <Box color="text.secondary" fontSize={12}>
              EMAIL
            </Box>
          </Typography>
        </Col>
        <Col xs={8}>
          <Typography component="div">
            <Box component="a" href="mailto:MSAFNOL@afics.com" color="primary.main" fontSize={14} style={{ textDecoration: 'none', wordBreak: 'break-all' }}>
              MSAFNOL@afics.com
            </Box>
          </Typography>
        </Col>
      </Row>

      <Row spacing={3} mb={3} alignItems="flex-start">
        <Col xs={4}>
          <Typography component="div">
            <Box color="text.secondary" fontSize={12}>
              ONLINE
            </Box>
          </Typography>
        </Col>
        <Col xs={8}>
          <Typography component="div">
            <Box
              component="a"
              href="https://www.msainsurance.com/claims"
              target="_blank"
              color="primary.main"
              fontSize={14}
              style={{ textDecoration: 'none', wordBreak: 'break-all' }}>
              www.msainsurance.com/claims
            </Box>
          </Typography>
        </Col>
      </Row>

      <Row spacing={3} mb={3} alignItems="flex-start">
        <Col xs={4}>
          <Typography component="div">
            <Box color="text.secondary" fontSize={12}>
              MAIL
            </Box>
          </Typography>
        </Col>
        <Col xs={8}>
          <Typography component="div">
            <Box fontSize={14}>
              Attention: Claims Mail
              <br />
              American Family Mutual Insurance Company
              <br />
              6000 American Parkway
              <br />
              Madison, WI 53783
            </Box>
          </Typography>
        </Col>
      </Row>

      <Row spacing={3} mb={3} alignItems="flex-start">
        <Col xs={4}>
          <Typography component="div">
            <Box color="text.secondary" fontSize={12}>
              SEND DOCUMENTS
            </Box>
          </Typography>
        </Col>
        <Col xs={8}>
          <Typography component="div">
            <Box
              component="a"
              href="mailto:claimdocuments@afics.com"
              color="primary.main"
              fontSize={14}
              style={{ textDecoration: 'none', wordBreak: 'break-all' }}>
              claimdocuments@afics.com
            </Box>
          </Typography>
        </Col>
      </Row>

      <Row spacing={3} mb={3} alignItems="flex-start">
        <Col xs={4}>
          <Typography component="div">
            <Box color="text.secondary" fontSize={12}>
              WORKERS COMP NEW CLAIM
            </Box>
          </Typography>
        </Col>
        <Col xs={8}>
          <Typography component="div">
            <Box
              component="a"
              href="mailto:9661AmFamMSA@Sedgwick.com"
              color="primary.main"
              fontSize={14}
              style={{ textDecoration: 'none', wordBreak: 'break-all' }}>
              9661AmFamMSA@Sedgwick.com
            </Box>
          </Typography>
        </Col>
      </Row>
    </Paper>
  );
};

export default OneStopClaimReporting;
